export const common = {
  nav: {
    home: "Home",
    about: "About Us",
    projects: "Projects",
    news: "News",
    getInvolved: "Get Involved",
    donateNow: "Donate Now"
  },
  footer: {
    about: {
      description: "Empowering refugees and vulnerable communities in the Democratic Republic of Congo through emergency aid, healthcare, education, and sustainable development."
    },
    newsletter: {
      placeholder: "Enter your email"
    },
    quickLinks: {
      title: "Quick Links",
      home: "Home",
      about: "About Us",
      projects: "Projects",
      news: "News",
      getInvolved: "Get Involved",
      contact: "Contact Us"
    },
    social: {
      title: "Connect With Us"
    },
    copyright: "© 2024 BridgeCore empowermennt initiative. All rights reserved."
  },
  buttons: {
    donate: "Donate",
    volunteer: "Volunteer",
    learnMore: "Learn More",
    readMore: "Read More",
    viewAll: "View All"
  }
};
